import React, { useState, useEffect, useRef } from 'react';

import BdsTooltip from '../../../BdsTooltip/BdsTooltip';

import './TruncatedText.scss';

interface TruncatedTextProps {
  text: string;
  maxWidth?: string;
  lines?: number;
}

const TruncatedText = ({ text, maxWidth = '200px', lines = 2 }: TruncatedTextProps) => {
  const [isTruncated, setIsTruncated] = useState<boolean>(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        if (lines === 1) {
          const { scrollWidth, clientWidth } = textRef.current;
          setIsTruncated(scrollWidth > clientWidth);
        } else {
          const { scrollHeight, clientHeight } = textRef.current;
          setIsTruncated(scrollHeight > clientHeight);
        }
      }
    };

    checkTruncation();
    window.addEventListener('resize', checkTruncation);

    return () => {
      window.removeEventListener('resize', checkTruncation);
    };
  }, [text, lines]);

  const textContent = () => (
    <div
      className={`truncated-text-container ${lines === 1 ? 'truncated-one-line' : 'truncated-multi-line'}`}
      style={lines === 1 ? { maxWidth } : { maxWidth, WebkitLineClamp: lines }}
      ref={textRef}
    >
      {text}
    </div>
  );

  if (!isTruncated) {
    return textContent();
  }

  return (
    <div style={{ maxWidth }}>
      <BdsTooltip message={text} position="top-center">
        {textContent()}
      </BdsTooltip>
    </div>
  );
};

export default TruncatedText;
